import { Badge, Spinner } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { NotesFieldStatus } from "./useBuyerReviewNotesEditor";

export const SaveStatusBadge = ({ status }: { status: NotesFieldStatus }) => {
  const { t } = useTranslation();
  if (status === "saving" || status === "pending") {
    return (
      <Badge colorScheme="gray" fontWeight="normal" display="inline-flex" alignItems="center" gap="1">
        <Spinner size="xs" />
        {t("Saving…")}
      </Badge>
    );
  }
  if (status === "saved") {
    return (
      <Badge colorScheme="gray" fontWeight="normal">
        {t("Saved")}
      </Badge>
    );
  }
  if (status === "error") {
    return (
      <Badge colorScheme="red" fontWeight="normal">
        {t("Could not save")}
      </Badge>
    );
  }
  return null;
};
